/**
 * File download utilities.
 */

/**
 * Delay in milliseconds before revoking blob URL.
 * Ensures browser has time to start the download.
 */
const URL_REVOKE_DELAY_MS = 100;

/**
 * Download a Blob as a file.
 * Handles URL creation and cleanup automatically.
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  // Delay URL revocation to ensure download starts
  setTimeout(() => URL.revokeObjectURL(url), URL_REVOKE_DELAY_MS);
};

/**
 * Download a string as a text file.
 */
export const downloadText = (content: string, filename: string, mimeType = 'text/plain'): void => {
  const blob = new Blob([content], { type: mimeType });
  downloadBlob(blob, filename);
};

/**
 * Download data as a JSON file.
 */
export const downloadJson = (data: unknown, filename: string): void => {
  const content = JSON.stringify(data, null, 2);
  downloadText(content, filename, 'application/json');
};

/**
 * Download data as a CSV file.
 */
export const downloadCsv = (content: string, filename: string): void => {
  downloadText(content, filename, 'text/csv');
};
